// @flow
import { publish, publishSticky, subscribe, unsubscribe } from '@wh/message-bus';
import { default as LoginIntegration } from './login-integration';
import * as LoginIntegrationConstants from './constants';
import './main.scss';

global.WH = global.WH || {};
global.WH.messageBus = global.WH.messageBus || { publish, publishSticky, subscribe, unsubscribe };

/*
 * Update window WH object to contain:
 * - Login Component (external render method prepared to be used as
 *   normal JS method anywhere inside the project)
 * - Login Component constants (PubSub/MessageBus channels)
 */
Object.assign(global.WH, { LoginIntegration, LoginIntegrationConstants });



// WEBPACK FOOTER //
// ./src/main/index.js